/** 将管理后台可输入文本的字段标记为新密码用途，避免 Chrome 展示已记忆的表单值。 */
export function suppressBrowserAutocomplete(root: ParentNode = document): void {
    const selector =
        'input:not([type]), input[type="text"], input[type="search"], input[type="number"], input[type="email"], input[type="tel"], input[type="url"], textarea';
    const fields = Array.from(root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(selector));
    if (root instanceof Element && root.matches(selector)) {
        fields.unshift(root as HTMLInputElement | HTMLTextAreaElement);
    }
    fields.forEach(input => input.setAttribute("autocomplete", "new-password"));
}

/** 安装全局输入监听，覆盖首屏字段及 Select 等组件后续创建的搜索输入框。 */
export function installBrowserAutocompletePolicy(root: HTMLElement = document.documentElement): () => void {
    suppressBrowserAutocomplete(root);

    const observer = new MutationObserver(records => {
        records.forEach(record => {
            record.addedNodes.forEach(node => {
                if (node instanceof HTMLElement) suppressBrowserAutocomplete(node);
            });
        });
    });
    observer.observe(root, { childList: true, subtree: true });

    return () => observer.disconnect();
}
